/**
 * 流拍提醒弹窗
 * @params id（required）
 * */
export { showAbortiveAuction } from '@/components/AbortiveAuction';
/**
 * 发起争议弹窗
 * @params id（required）
 * */
export { showInitiateDispute } from '@/components/InitiateDispute';
export { showDaYuDispute } from '@/components/DaYuDispute';
/**
 * 发起争议弹窗
 * @params id（required）
 * */
// export { disputeReason } from '@/components/disputeReason';
/**
 * 争议处理弹窗
 */
export { showDealDispute } from '@/components/DealDispute';
/**
 * 违约处理弹窗
 */
export { showDealBreakContract } from '@/components/DealBreakContract';
/**
 * info弹窗：查看买 卖方详情，争议 驳回原因，处理详情
 * */
export { showInfo, loading } from '@/components';
/**
 * 驳回弹窗
 * @params id(required)
 * @parasm callback 驳回之后回调函数
 * */
export { showRejectReason } from '@/components';
/**
 * 出价记录。流拍记录，修改记录
 * @params id (required)
 * @params type 'edit':修改记录 | 'auction'：流拍记录 | 'offer'：出价记录;
 * @parasm callback 驳回之后回调函数
 * */
export { showRecord } from '@/components';
/**
 * 查看合同
 * */
export { showContract } from '@/components/ShowContract';
/**
 * 查看车辆详情
 * */
export { showCarDetail } from '@/components/CarDetail';
export const fontEndConfig = {
    noValueReplace: '--',
};
/**
 * 查看会员数 出价会员数|关注会员|在线会员|本机构关注会员|本机构出价会员|本机构在线会员
 * */
export { showMembersList } from '@/components/MembersList';
/**
 * 正常成交
 */
export { ShowNormalDeal } from '@/components/DealComponent/normalDeal';
/**
 * 违约
 */
export { ShowBreakContract } from '@/components/BreakContract';
/**
 * 撮合成交
 */
export { ShowBrokeredDeal } from '@/components//BrokeredDeal/winningDeal';
